import i18n from 'i18n-js';
import translations from './locales';

const translate = () => {
  i18n.fallbacks = true;
  i18n.translations = translations;

  const defaultLang = 'en_us';

  let currentLanguage = navigator
    ? navigator.language || navigator.userLanguage || defaultLang
    : defaultLang;
  currentLanguage =
    currentLanguage === 'en' ? defaultLang : currentLanguage?.toLowerCase().replace('-', '_');

  const hasSpecificLanguage = translations[currentLanguage];
  const hasCommonTranslation = translations[currentLanguage.split('_')[0]];

  if (hasSpecificLanguage) {
    // Use specific translation if available, ex: es_419
    i18n.locale = currentLanguage;
  } else if (hasCommonTranslation) {
    // Fallback to language without region, ex: es_419 -> es
    i18n.locale = currentLanguage.split('_')[0];
  } else {
    // Fallback to default language (en_us)
    i18n.locale = defaultLang;
  }

  // Fallback to en_us for mission translation on other languages
  i18n.defaultLocale = defaultLang;

  i18n.missingTranslation = (val) => val;
};

export default translate;
